module.exports = __webpack_public_path__ + "img/diamond-4.21f27adc.png";